import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import WOW from "wowjs";
import "animate.css";

function About() {

  useEffect(() => {
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  return (
    <>
      <Helmet>
        <title>About Us | Primedale - Professional Services in Kenya</title>
        <meta
          name="description"
          content="Learn about Primedale Tours & Travel, a trusted travel company in Kenya offering safaris, corporate travel, and international holiday packages."
        />
        <meta
          name="keywords"
          content="Primedale tours, Kenya safaris, corporate travel, MICE services, travel agency Kenya"
        />
        <link rel="canonical" href="https://primedale.gtreksolution.co.ke/about" />
      </Helmet>

      <div>
        {/* Hero Section */}
        <div className="container-fluid bg-dark py-5 mb-5 hero-header">
          <div className="container py-5">
            <div className="row justify-content-center py-5">
              <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center wow fadeInUp">
                <h2 className="display-5 text-white animated slideInDown">
                  About Primedale Tours & Travel
                </h2>
                <p className="text-white mt-3">
                  Trusted tours and travel experts in Kenya offering safaris,
                  corporate travel, and international holiday experiences.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Who We Are */}
        <div className="container-xxl py-5">
          <div className="container">
            <div className="row g-5 align-items-center">
              <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s">
                <div className="position-relative h-100" style={{ minHeight: 400 }}>
                  <img
                    className="img-fluid position-absolute w-100 h-100"
                    src="/assets/img/aboutus.jpg"
                    alt="About Primedale"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </div>

              <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.3s">
                <h6 className="section-title bg-white text-start icon-color pe-3">
                  <span className="footer-color">Who We Are</span>
                </h6>
                <h1 className="h4">About Primedale Tours & Travel</h1>

                <p>
                  Primedale Tours & Travel is a trusted tours and travel company in Kenya
                  specializing in safaris, international holiday packages, corporate travel
                  management, and MICE services.
                </p>

                <p>
                  Based in Kenya, we curate carefully planned trips across Kenya, Africa,
                  and international destinations, ensuring that every journey is memorable,
                  well organized, and tailored to our clients’ needs.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* What We Do */}
        <div className="container-xxl py-5 bg-light">
          <div className="container">
            <div className="text-center mb-5 wow fadeInUp">
              <h6 className="section-title bg-white text-center icon-color px-3">
                <span className="footer-color">What We Do</span>
              </h6>
              <h1>Our Travel Services</h1>
            </div>

            <div className="row g-4">
              <div className="col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                <ul>
                  <li>Kenya wildlife safaris and tour packages</li>
                  <li>Beach holidays to Diani, Mombasa, Zanzibar, Seychelles</li>
                  <li>International holidays: Dubai, Bali, Singapore, Thailand, Cape Town</li>
                  <li>Corporate travel management</li>
                </ul>
              </div>

              <div className="col-md-6 wow fadeInUp" data-wow-delay="0.3s">
                <ul>
                  <li>MICE services (meetings, conferences, incentives)</li>
                  <li>Team building experiences</li>
                  <li>Group travel planning</li>
                  <li>Reliable travel logistics and support</li>
                </ul>
              </div>
            </div>

            <p className="mt-4 text-center wow fadeInUp" data-wow-delay="0.5s">
              We work with trusted partners to ensure high-quality service,
              reliability, and competitive travel packages.
            </p>
          </div>
        </div>

        {/* Our Approach */}
        <div className="container-xxl py-5">
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s">
                <h6 className="section-title footer-color bg-white text-start icon-color pe-3">
                  <span className="footer-color">Our Approach</span>
                </h6>
                <h1 className="h4 mb-4">How We Work</h1>

                <p>
                  We believe that every traveller is different. That’s why we focus on
                  personalized travel planning tailored to your interests, schedule,
                  and budget.
                </p>

                <p>
                  From your first inquiry to your return home, our team ensures smooth
                  planning, reliable support, and a stress-free travel experience.
                </p>
              </div>

              <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.3s">
                <div className="position-relative h-100" style={{ minHeight: 400 }}>
                  <img
                    className="img-fluid position-absolute w-100 h-100"
                    src="/assets/img/abouts.jpg"
                    alt="Our Approach"
                    style={{ objectFit: "cover" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="container-xxl py-5 bg-light">
          <div className="container">
            <div className="row g-5 align-items-center">
              <div className="col-lg-6 wow fadeInLeft">
                <h6 className="section-title bg-white text-start icon-color pe-3">
                  <span className="footer-color">Why Travel With Primedale?</span>
                </h6>
                <h1 className="h4">Why Choose Us</h1>

                <ul>
                  <li>Tailor-made travel packages</li>
                  <li>Experienced travel consultants</li>
                  <li>Reliable transfers and logistics</li>
                  <li>Corporate travel expertise</li>
                  <li>Personalized customer support</li>
                  <li>Competitive travel packages</li>
                </ul>

                <p className="mt-3">
                  Our goal is to make travel easy, enjoyable, and unforgettable.
                </p>
              </div>

              <div className="col-lg-6 wow fadeInRight">
                <div className="bg-white p-4 shadow-sm">
                  <h5>Our Vision</h5>
                  <p>
                    To become a leading tours and travel company in Kenya and Africa,
                    known for delivering exceptional travel experiences.
                  </p>

                  <h5 className="mt-4">Our Mission</h5>
                  <p>
                    To provide reliable, personalized, and high-quality travel services
                    that connect people to unforgettable destinations worldwide.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="container-xxl py-5 bg-light text-center">
          <div className="container wow zoomIn">
            <h3 className="mb-4 icon-color">Let’s Plan Your Next Journey</h3>
            <p className="mb-4">
              Whether you're planning a Kenya safari, beach holiday, corporate trip,
              or international tour, we are ready to help.
            </p>
            <a className="btn icon-color py-3 px-5 me-3" href="/contact">
              Contact Us
            </a>
            <a className="btn py-3 px-5" href="/services">
              Services
            </a>
          </div>
        </div>

      </div>
    </>
  );
}

export default About;